import { render, staticRenderFns } from "./taskcenter.vue?vue&type=template&id=6428f7e0&scoped=true&"
import script from "./taskcenter.vue?vue&type=script&lang=js&"
export * from "./taskcenter.vue?vue&type=script&lang=js&"
import style0 from "./taskcenter.vue?vue&type=style&index=0&id=6428f7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6428f7e0",
  null
  
)

export default component.exports